import React from 'react';
import { Button, Form } from "react-bootstrap";

const StepOne = ({ activeStep, setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Motor Vehicle Record (MVR)</h5>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Authorization for MVR Check:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Authorization for MVR Check" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Driver’s License Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Driver’s License Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>State of Issue:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter State of Issue" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>MVR Expiration Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter MVR Expiration Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Upload MVR Report:</Form.Label>
                                                <Form.Control type="file" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(4)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(6)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepOne;